<template>
    <div>

        <v-container fluid class="pa-8 pt-4 pb-0">
            <v-row dense>

                <v-col cols="12" md="4" lg="3" xl="2">
                    <stat-box-text
                        v-if="status"
                        :color="status.color"
                        :value="status.value"
                        hint="Status"
                        :mouse-over-value="toLocalDate(status.date)"
                        mouse-over-hint="On date"
                    ></stat-box-text>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="daysInPanel">
                    <stat-box-numerical
                        :value="daysInPanel"
                        hint="Days in panel"
                    ></stat-box-numerical>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="responseRate!==false">
                    <stat-box-numerical
                        :value="responseRate"
                        postfix="%"
                        hint="Response rate"
                    ></stat-box-numerical>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="numberOfActivities">
                    <stat-box-numerical
                        :value="numberOfActivities"
                        hint="Total activities"
                    ></stat-box-numerical>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="completedProjects">
                    <stat-box-numerical
                        :value="completedProjects"
                        hint="Completed projects"
                    ></stat-box-numerical>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="suspicious && suspicious.value">
                    <stat-box-text
                        :color="suspicious.color"
                        value="Suspicious"
                        hint="This panelist should be reviewed"
                    ></stat-box-text>
                </v-col>

                <v-col cols="12" md="4" lg="3" xl="2" v-if="completedProjects">
                    <stat-box-numerical
                        :value="pointsBalance"
                        hint="Reward points balance"
                    ></stat-box-numerical>
                </v-col>

            </v-row>
        </v-container>

        <v-card flat>
            <v-card-text class="pt-2 pl-8 pr-8">

                <v-container fluid class="pa-0">
                    <v-row dense>

                        <!-- BASIC INFO -->
                        <v-col cols="12" md="6">

                            <title-card title="Basics" help="edit-panelist-basics" no-padding>

                                <v-list dense color="grey darken-2" class="pa-0">

                                    <div v-if="!isExternallySupplied">

                                        <v-list-item dense @click="">

                                            <label-value label="Name"
                                                         :value="fullName"/>

                                        </v-list-item>

                                        <v-divider></v-divider>


                                        <v-list-item @click="">

                                            <label-value label="Age"
                                                         :value="age"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="Gender"
                                                         :value="gender"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="Email"
                                                         :value="email"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="Email valid"
                                                         :value="emailValid"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="Email confirmed"
                                                         :value="emailConfirmed"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="Recruitment source"
                                                         :value="recruitmentSource"/>

                                        </v-list-item>

                                        <v-divider></v-divider>
                                    </div>

                                    <v-list-item @click="">

                                        <label-value label="Identifier"
                                                     :value="identifier"/>

                                        <v-divider></v-divider>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="Auth provider"
                                                     :value="data.auth_provider ? ucFirst(data.auth_provider) : 'Sample Ninja'"/>

                                    </v-list-item>

                                    <div v-if="isExternallySupplied">

                                        <div v-if="data.external_supplier_name">
                                            <v-divider></v-divider>

                                            <v-list-item @click="">

                                                <label-value label="External supplier"
                                                             :value="data.external_supplier_name"/>

                                            </v-list-item>
                                        </div>

                                        <v-list-item @click="">
                                            <label-value label="External supplier ID"
                                                         :value="data.external_supplier_id"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                        <v-list-item @click="">

                                            <label-value label="External identifier"
                                                         :value="data.external_identifier"/>

                                        </v-list-item>
                                    </div>

                                </v-list>

                            </title-card>
                        </v-col>

                        <!-- PROJECT STATS -->
                        <v-col cols="12" md="6">
                            <title-card title="Projects" no-padding help="edit-panelist-projects">
                                <v-list color="grey darken-2" dense class="pa-0">

                                    <div v-if="!isExternallySupplied">

                                        <v-list-item @click="">

                                            <label-value label="# of invitations"
                                                         :value="invitedCount"/>

                                        </v-list-item>

                                        <v-divider></v-divider>


                                        <v-list-item @click="">

                                            <label-value label="# of invitations opened"
                                                         :value="openedCount"/>

                                        </v-list-item>

                                        <v-divider></v-divider>

                                    </div>

                                    <v-list-item @click="">

                                        <label-value label="# of started"
                                                     :value="startedCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of quota"
                                                     :value="quotaCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of profile"
                                                     :value="profileCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of quality"
                                                     :value="qualityCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of duplicate"
                                                     :value="duplicateCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of security"
                                                     :value="securityCount"/>

                                    </v-list-item>

                                    <v-divider></v-divider>

                                    <v-list-item @click="">

                                        <label-value label="# of completed"
                                                     :value="completedCount"/>

                                    </v-list-item>

                                </v-list>
                            </title-card>
                        </v-col>

                        <!-- SUB PANELS -->
                        <v-col cols="12" md="6" v-if="subPanelMemberShips">

                            <title-card title="Sub panel" no-padding help="edit-panelist-sub-panel" v-show="!isExternallySupplied">
                                <v-list dense color="grey darken-2" class="pa-0">
                                    <v-list-item v-for="subPanel in subPanelMemberShips"
                                                 :key="subPanel.uuid">

                                        <label-value
                                            :label="subPanel.name"
                                            :value="subPanel.codes"
                                        />

                                    </v-list-item>
                                </v-list>
                            </title-card>
                        </v-col>

                        <!-- LOCALE -->
                        <v-col cols="12" md="6" v-if="panelistLocale">

                            <v-container fluid class="pa-0">
                                <v-row no-gutters class="align-center">

                                    <v-col cols="10">
                                        <title-card title="Locale" no-padding help="edit-panelist-locale">
                                            <v-list color="grey darken-2" dense class="pa-0">
                                                <v-list-item>

                                                    <label-value
                                                        :label="panelistLocale.code"
                                                        :value="panelistLocale.country + ' - ' + panelistLocale.language"
                                                    />

                                                </v-list-item>
                                            </v-list>
                                        </title-card>
                                    </v-col>

                                    <v-col cols="2" class="text-center pl-4">
                                        <locale-flag :locale="panelistLocale"/>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-col>

                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card-text class="pl-6 pt-0 d-flex" v-if="!isExternallySupplied">

            <!-- CHANGE STATUS SELECT -->
            <v-select v-model="panelistStatusModel"
                      :items="panelistStatuses"
                      item-text="name"
                      item-value="value"
                      v-if="hasPermission('update panelists')"
                      solo
                      dense
                      hide-details
                      label="Change panelist status"
                      :background-color="statusColor"
                      style="max-width: 200px;"
                      class="ml-2 align-self-center"
                      :key="'status' + statusKey"
            ></v-select>

            <!-- CLEAR SUSPICIOUS BUTTON -->
            <v-scale-transition>
                <v-btn color="primary"
                       class="ml-2 align-self-center"
                       :loading="clearSuspiciousButtonLoading"
                       v-if="showClearSuspiciousButton && hasPermission('update panelists')"
                       @click="clearSuspiciousClicked">
                    Clear suspicious
                </v-btn>
            </v-scale-transition>

            <!-- RESET PASSWORD BUTTON -->
            <v-scale-transition>
                <v-btn
                    v-if="showResetPasswordButton && hasPermission('update panelists')"
                    color="primary"
                    class="ml-2 align-self-center"
                    :loading="resetPasswordLoading"
                    @click="resetPasswordClicked">
                    Reset password
                </v-btn>
            </v-scale-transition>

            <!-- CREATE PASSWORD BUTTON -->
            <v-scale-transition>
                <v-btn
                    v-if="showCreatePasswordButton && hasPermission('update panelists')"
                    color="primary"
                    class="ml-2 align-self-center"
                    :loading="createPasswordLoading"
                    @click="createPasswordClicked">
                    Create password
                </v-btn>
            </v-scale-transition>

            <!-- DELETE PANELIST BUTTON -->
            <v-scale-transition>
                <v-btn text
                       class="ml-2 align-self-center"
                       :loading="deleteButtonLoading"
                       v-if="hasPermission('delete panelists')"
                       @click="deleteClicked">
                    Delete panelist
                </v-btn>
            </v-scale-transition>

        </v-card-text>

        <!-- DEBUG -->
        <v-col cols="12" v-if="debug">
            <v-card color="blue-grey darken-4">
                <v-card-title>
                    <v-icon large class="mr-2">mdi-bug</v-icon>
                    <h3>Debug</h3>
                </v-card-title>
                <v-card-text>
                    <json :data="data"></json>
                </v-card-text>
            </v-card>
        </v-col>

        <!-- DELETE PANELIST CONFIRMATION DIALOG -->
        <confirmation-dialog
            v-model="confirmationDialogModel"
            headline="Delete panelist?"
            :description="deletePanelistDescription"
            @selected="confirmationDialogEntry"
            delete
        />

        <!-- UNSUBSCRIBE CONFIRMATION DIALOG -->
        <confirmation-dialog
            v-model="unsubscribeDialogModel"
            headline="Unsubscribe panelist?"
            :description="unsubscribeDialogDescription"
            @selected="unsubscribeDo"
            delete
        />

        <!-- BLACKLIST CONFIRMATION DIALOG -->
        <confirmation-dialog
            v-model="blacklistDialogModel"
            headline="Blacklist panelist?"
            :description="blacklistDialogDescription"
            @selected="blacklistDo"
            delete
        />

    </div>

</template>

<script>

import Json from 'vue-json-pretty';
import RetroValue from "../../../../components/UI/RetroValue";
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import LocaleFlag from "../../../../components/UI/LocaleFlag";
import StatBoxText from "../../../../components/UI/StatBoxText";
import moment from 'moment/moment';
import LabelValue from "../../../../components/UI/LabelValue";
import {timeDisplay} from '../../../../components/mixins/timeDisplayMixin';
import ConfirmationDialog from '../../../../components/UI/ConfirmationDialog';
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import TitleCardList from "../../../../components/UI/TitleCardList";
import TitleCard from "../../../../components/UI/TitleCard";

export default {

    mixins: [timeDisplay],

    components: {
        Json,
        RetroValue,
        StatBoxNumerical,
        StatBoxText,
        LabelValue,
        ConfirmationDialog,
        LocaleFlag,
        TitleCardList,
        TitleCard
    },

    props: {
        data: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            debug: false,
            confirmationDialogModel: false,
            blacklistDialogModel: false,
            unsubscribeDialogModel: false,
            subscribeButtonLoading: false,
            unsubscribeButtonLoading: false,
            blacklistButtonLoading: false,
            clearSuspiciousButtonLoading: false,
            deleteButtonLoading: false,
            resetPasswordLoading: false,
            createPasswordLoading: false,
            unsubscribeDialogDescription: 'Are you sure you want to unsubscribe this panelist? ' +
                'Due to the consumer data protection laws around the world ' +
                'we will automatically delete all collected data variables including email and name in ' +
                'the next 24 hours. Panelist\'s activity, reward points and redemption history are kept in place for ' +
                'one year for reporting purposes.',
            blacklistDialogDescription: 'Are you sure you want to blacklist this panelist? ' +
                'Due to the consumer data protection laws around the world ' +
                'we will automatically delete all collected data variables including first and last name in ' +
                'the next 24 hours. Panelist\'s activity, reward points and redemption history are kept in place for ' +
                'one year for reporting purposes. Panelist\'s email address remains on the blacklist ' +
                'so that this individual cannot join your panel again.',
            deletePanelistDescription: 'Are you sure you want to delete this panelist? ' +
                'If you proceed we will delete the entire panelist record including all project participation records. ' +
                'This operating will have an impact on your project statistics. ' +
                'We recommend that you set the panelist\'s status to Unsubscribed or Blacklisted. ' +
                'Sample Ninja will automatically delete any unsubscribed or blacklisted panelists after 12 months.',
            oldStatus: null,
            statusKey: 1,
        }
    },

    computed: {
        ...mapState('PanelSettings', [
            'settings',
        ]),

        ...mapState('SubPanels', [
            'subPanels',
        ]),

        isExternallySupplied() {
            return this.data.external_supplier_id;
        },

        panelistStatuses() {

            if (this.panelistStatusModel === "blacklisted") {
                return [
                    {name: 'Blacklisted', value: 'blacklisted'},
                ];
            }

            if (this.panelistStatusModel === "unsubscribed") {
                return [
                    {name: 'Unsubscribed', value: 'unsubscribed'},
                    {name: 'Blacklisted', value: 'blacklisted'},
                ];
            }

            return [
                {name: 'Subscribed', value: 'subscribed'},
                {name: 'Unsubscribed', value: 'unsubscribed'},
                {name: 'Blacklisted', value: 'blacklisted'},
            ];
        },

        panelistStatusModel: {

            get() {
                return this.currentStatus;
            },

            set(newValue) {
                if (this.currentStatus !== newValue) {
                    if (newValue === 'subscribed') this.subscribeClicked();
                    if (newValue === 'unsubscribed') this.unsubscribeClicked();
                    if (newValue === 'blacklisted') this.blacklistClicked();
                }
            }
        },

        statusColor() {
            if (this.panelistStatusModel === 'subscribed') return 'green';
            if (this.panelistStatusModel === 'unsubscribed') return 'red';
            if (this.panelistStatusModel === 'blacklisted') return 'grey darken-4';
        },

        showResetPasswordButton() {
            if (this.panelistStatusModel === "subscribed") {
                return !!this.data.password;
            }
            return false;
        },

        showCreatePasswordButton() {

            // TODO: Check if panelist has password
            if (this.panelistStatusModel === "subscribed") {
                return !this.data.password;
            }
            return false;
        },

        showClearSuspiciousButton() {
            return this.panelistStatusModel === "subscribed" &&
                this.data.data_variables &&
                this.suspicious.value && this.hasPermission('update panelists');
        },

        panelistLocale() {
            if (this.data.data_variables && this.settings) {
                // Locale
                let localeVar = this.data.data_variables.find(item => item.dataVariable.uuid === 'GKIPtxsC0c33qz8aAlqtC');
                return this.settings.locales.find(locale => locale.id === localeVar.recorded_value);
            }
            return null;
        },

        pointsBalance() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '7bKVueK9A2FomeRePAiKyR');
                return parseInt(dataVar.recorded_value);
            }
            return 0;
        },

        subPanelMemberShips() {
            // Wait till both arrays are async loaded
            if (this.data.sub_panels && this.subPanels.length > 0) {

                let subPanels = [];
                this.data.sub_panels.forEach(subPanelUuid => {

                    const subPanel = this.subPanels.find(sp => sp.uuid === subPanelUuid);

                    const item = {
                        name: subPanel.name,
                        uuid: subPanel.uuid,
                        codes: subPanel.locales.map(locale => locale.code).join(' , ')
                    }
                    subPanels.push(item);
                });

                return subPanels;
            }
            return null;
        },

        numberOfActivities() {
            if (this.data.activity_history) {
                return this.data.activity_history.length;
            }
        },

        completedProjects() {
            if (this.data.data_variables) {
                return this.data.data_variables.find(item => item.dataVariable.uuid === '3feIg4mar78tbKVpSuK5t8').recorded_value;
            }
        },

        responseRate() {
            if (this.data.data_variables) {
                if (this.invitedCount > 0) {
                    if (this.startedCount === 0) return 0;
                    return Math.floor(this.startedCount / this.invitedCount * 100);
                }
            }

            return false;
        },

        identifier() {
            return this.data.panelist_id ? this.data.panelist_id : '';
        },

        status() {

            if (this.data.data_variables) {
                // STATUS_NAME
                let statusVar = this.data.data_variables.find(item => item.dataVariable.uuid === '5EGhEoP1OBuztSfKxkfBsi');

                if (statusVar) {
                    if (statusVar.recorded_value === 1) {
                        this.panelistStatusModel = 'subscribed';
                        let date = this.data.data_variables.find(item => item.dataVariable.uuid === '3PceiALrSPB7Lv8Fya5ST2');
                        return {value: "Subscribed", color: 'green', date: date.recorded_value};
                    }
                    if (statusVar.recorded_value === 2) {
                        this.panelistStatusModel = 'unsubscribed';
                        let date = this.data.data_variables.find(item => item.dataVariable.uuid === '6YIHCtpzuU7z7zplxUju2C');
                        return {value: "Unsubscribed", color: 'red', date: date};
                    }
                    if (statusVar.recorded_value === 3) {
                        this.panelistStatusModel = 'blacklisted';
                        let date = this.data.data_variables.find(item => item.dataVariable.uuid === '5PerQOf99koSq3uNFgLZHo');
                        return {value: "Blacklisted", color: 'grey darken-4', date: date};
                    }
                }
            }
        },

        currentStatus() {
            if (this.data.data_variables) {

                let statusVar = this.data.data_variables.find(item => item.dataVariable.uuid === '5EGhEoP1OBuztSfKxkfBsi');
                let status = null;

                if (statusVar.recorded_value === 1) status = 'subscribed';
                if (statusVar.recorded_value === 2) status = 'unsubscribed';
                if (statusVar.recorded_value === 3) status = 'blacklisted';

                this.oldStatus = status;

                return status;
            }
        },

        suspicious() {
            if (this.data.data_variables) {
                // STATUS_NAME
                let statusVar = this.data.data_variables.find(item => item.dataVariable.uuid === '3d6p40dhXsvkDLm4arCs0l');

                if (statusVar) {
                    if (statusVar.recorded_value === 1) return {value: true, color: 'red'};
                    if (statusVar.recorded_value === 2) return {value: false, color: 'green'};
                }
            }
        },


        fullName() {
            if (this.data.data_variables) {

                // FIRST_NAME
                let firstNameVar = this.data.data_variables.find(item => item.dataVariable.uuid === '6srod1F590JD0u1iGjwsW');
                let lastNameVar = this.data.data_variables.find(item => item.dataVariable.uuid === '7ISQaKgQBQoBRNGobStY9m');

                if (firstNameVar && lastNameVar) {

                    let firstName = '';
                    let lastName = '';

                    if (firstNameVar.dataVariable.pi && !this.hasPermission('view pi')) {
                        firstName = "";

                    } else {
                        firstName = firstNameVar.recorded_value;
                    }

                    if (lastNameVar.dataVariable.pi && !this.hasPermission('view pi')) {
                        lastName = "";
                    } else {
                        lastName = lastNameVar.recorded_value;
                    }

                    return firstName + ' ' + lastName;
                }
            }
        },

        age() {
            if (this.data.data_variables) {
                let birthDateVar = this.data.data_variables.find(item => item.dataVariable.uuid === '1lbJlPvf566FGkQ6tM1l4s');

                if (birthDateVar) {
                    if (birthDateVar.dataVariable.pi && !this.hasPermission('view pi')) return "XXXXXXXX";
                    const birthDate = moment(birthDateVar.recorded_value);
                    // Get age
                    return Math.abs(birthDate.diff(moment(), 'years'));
                }
            }
        },

        email() {
            if (this.data.data_variables) {
                // EMAIL
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '4b9KWeVNAB0cEG4evmUpUT');
                if (dataVar) {
                    if (dataVar.dataVariable.pi && !this.hasPermission('view pi')) return "XXXXXXXX";
                    return dataVar.recorded_value;
                }
            }
        },

        emailValid() {
            if (this.data.data_variables) {
                // EMAIL_VALID
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '2z5vLkkLSnl9UcWA5HwVpF');
                if (dataVar) {
                    return dataVar.recorded_value === 1 ? 'Yes' : 'No';
                }
            }
        },

        emailConfirmed() {
            if (this.data.data_variables) {
                // EMAIL_CONFIRMED
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === 'Xz5vLkkLanl4EcWA5HwVzA');
                if (dataVar) {
                    return dataVar.recorded_value === 1 ? 'Yes' : 'No';
                }
            }
        },

        gender() {
            if (this.data.data_variables) {
                // GENDER
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '4sxlsGeCj1vJGAqvi5ggeT');
                if (dataVar) {
                    if (dataVar.dataVariable.pi && !this.hasPermission('view pi')) return "XXXXXXXX";
                    return dataVar.recorded_value === 1 ? 'male' : 'female';
                }
            }
        },

        invitedCount() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '6lQL4CfaST4yY4m8lPIgtD');
                return dataVar.recorded_value;
            }
            return 0;
        },

        remindedCount() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '123L4CfaST4yAZ123DIgtD');

                if (!dataVar) return 0;
                return dataVar.recorded_value;
            }
            return 0;
        },

        startedCount() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '7d0Ztoj4Xm1q5pxhgw36EW');
                return dataVar.recorded_value;
            }
            return 0;
        },

        openedCount() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '5Cn0owCm3AqVB0Sk89ZUe');
                return dataVar.recorded_value;
            }
            return 0;
        },

        quotaCount() {
            if (this.data.data_variables) {
                let dataVarQuota = this.data.data_variables.find(item => item.dataVariable.uuid === 'AVvxmspZnROjn8SBC8mcF');
                return dataVarQuota.recorded_value;
            }
            return 0;
        },

        profileCount() {
            if (this.data.data_variables) {
                let dataVarProfile = this.data.data_variables.find(item => item.dataVariable.uuid === '4Ogk9phJWuIIqLU7ufG19b');
                return dataVarProfile.recorded_value;
            }
            return 0;
        },

        qualityCount() {
            if (this.data.data_variables) {
                let variable = this.data.data_variables.find(item => item.dataVariable.uuid === '4mar78tJWuIIqLU7u3feIg');
                if (!variable) return 0;
                return variable.recorded_value
            }
            return 0;
        },

        duplicateCount() {
            if (this.data.data_variables) {
                let variable = this.data.data_variables.find(item => item.dataVariable.uuid === 'vfxrabtJWuYYqLU7u3fe12');
                if (!variable) return 0;
                return variable.recorded_value
            }
            return 0;
        },

        securityCount() {
            if (this.data.data_variables) {
                let variable = this.data.data_variables.find(item => item.dataVariable.uuid === 'skjrabtJWsagtLU7u67412');
                if (!variable) return 0;
                return variable.recorded_value
            }
            return 0;
        },

        completedCount() {
            if (this.data.data_variables) {
                let dataVar = this.data.data_variables.find(item => item.dataVariable.uuid === '3feIg4mar78tbKVpSuK5t8');
                return dataVar.recorded_value;
            }
            return 0;
        },

        recruitmentSource() {
            if (this.data.recruitment_source) {
                return this.data.recruitment_source.name;
            }
        },

        daysInPanel() {
            if (this.data.data_variables) {
                // SUBSCRIBED_DATE
                let subscribed = this.data.data_variables.find(item => item.dataVariable.uuid === '3PceiALrSPB7Lv8Fya5ST2');
                let unsubscribed = this.data.data_variables.find(item => item.dataVariable.uuid === '6YIHCtpzuU7z7zplxUju2C');

                const subscribedDate = moment(subscribed.recorded_value);

                if (unsubscribed) {
                    const unsubscribedDate = moment(unsubscribed.recorded_value);
                    return Math.abs(subscribedDate.diff(unsubscribedDate, 'days'));
                } else {
                    // Get age
                    return Math.abs(subscribedDate.diff(moment(), 'days'));
                }
            }
            return 0;
        }
    },

    methods: {

        ...mapActions('PanelistManager', [
            'changeDataVariableRequest',
            'resetPassword',
            'createPassword'
        ]),

        subscribeClicked() {
            if (this.data.data_variables) {

                this.subscribeButtonLoading = true;
                let STATUS = this.data.data_variables.find(item => item.dataVariable.uuid === '5EGhEoP1OBuztSfKxkfBsi');

                const data = {
                    ids: [this.data.panelist_id],
                    dataVariableId: STATUS.dataVariable.uuid,
                    value: 1
                };

                this.changeDataVariableRequest(data)
                    .then(() => {
                        STATUS.recorded_value = 1;
                    })
                    .catch((error) => {
                        console.log(error);
                        Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                    })
                    .finally(() => {
                        this.subscribeButtonLoading = false;
                    })
            }
        },

        unsubscribeClicked() {
            if (this.data.data_variables) {
                this.unsubscribeDialogModel = true;
            }
        },

        unsubscribeDo(confirmed) {
            if (confirmed) {
                this.unsubscribeButtonLoading = true;
                let STATUS = this.data.data_variables.find(item => item.dataVariable.uuid === '5EGhEoP1OBuztSfKxkfBsi');

                const data = {
                    ids: [this.data.panelist_id],
                    dataVariableId: STATUS.dataVariable.id,
                    value: 2
                };

                this.changeDataVariableRequest(data)
                    .then(() => {
                        STATUS.recorded_value = 2;
                    })
                    .catch((error) => {
                        console.log(error);
                        Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                    })
                    .finally(() => {
                        this.unsubscribeButtonLoading = false;
                    })
            } else {
                this.statusKey++;
            }
        },

        blacklistClicked() {
            if (this.data.data_variables) {
                this.blacklistDialogModel = true;
            }
        },

        blacklistDo(confirmed) {

            if (confirmed) {

                if (this.data.data_variables) {
                    this.blacklistButtonLoading = true;
                    let STATUS = this.data.data_variables.find(item => item.dataVariable.uuid === '5EGhEoP1OBuztSfKxkfBsi');

                    const data = {
                        ids: [this.data.panelist_id],
                        dataVariableId: STATUS.dataVariable.uuid,
                        value: 3
                    };

                    this.changeDataVariableRequest(data)
                        .then(() => {
                            STATUS.recorded_value = 3;
                        })
                        .catch((error) => {
                            console.log(error);
                            Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                        })
                        .finally(() => {
                            this.blacklistButtonLoading = false;
                        })
                }
            } else {
                this.statusKey++;
            }
        },

        clearSuspiciousClicked() {
            if (this.data.data_variables) {
                this.clearSuspiciousButtonLoading = true;
                let SUSPICIOUS = this.data.data_variables.find(item => item.dataVariable.uuid === '3d6p40dhXsvkDLm4arCs0l');

                const data = {
                    ids: [this.data.panelist_id],
                    dataVariableId: SUSPICIOUS.dataVariable.uuid,
                    value: 2
                };

                this.changeDataVariableRequest(data)
                    .then(() => {
                        SUSPICIOUS.recorded_value = 2;
                    })
                    .catch(() => {
                        Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                    })
                    .finally(() => {
                        this.clearSuspiciousButtonLoading = false;
                    })
            }
        },

        resetPasswordClicked() {

            this.resetPasswordLoading = true;

            this.resetPassword(this.data.panelist_id)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Password reset email has been sent!'});
                })
                .catch((error) => {
                    if (error.response.status === 409) {
                        Bus.$emit('flash-message', {type: 'error', message: error.response.data.message});
                    } else {
                        Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                    }
                })
                .finally(() => {
                    this.resetPasswordLoading = false;
                });
        },

        createPasswordClicked() {

            this.createPasswordLoading = true;

            this.createPassword(this.data.panelist_id)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Password create email has been sent!'});
                })
                .catch((error) => {
                    if (error.response.status === 409) {
                        Bus.$emit('flash-message', {type: 'error', message: error.response.data.message});
                    } else {
                        Bus.$emit('flash-message', {type: 'error', message: 'Well that failed...'});
                    }
                })
                .finally(() => {
                    this.createPasswordLoading = false;
                });
        },

        deleteClicked() {
            this.confirmationDialogModel = true;
        },

        confirmationDialogEntry(value) {
            if (value) this.$emit('delete', this.data.panelist_id);
        }
    }
}

</script>
